// extracted by mini-css-extract-plugin
module.exports = {"Layout":"components_Layout__cT18y","Menu":"components_Menu__Ht_bE"};